



































































































































import { UserModule } from '@/store/modules/user';
import { gearApplyOverviewDatasApi } from '@/api/index';
import { Component, Vue, Watch } from 'vue-property-decorator';

@Component({
  name: 'businessOverview',
})
export default class extends Vue {
  get year() {
    return UserModule.indexSelectYear;
  }

  public commission: any = {
    applyTotal: '',
    enrollTotal: '',
    studentTotal : '',
    dataList: []
  }; // 已收佣金

  @Watch('year')
  public onYearChange(year: string) {
    this.gearApplyOverviewDatas()
  }

  public mounted() {
    this.gearApplyOverviewDatas();
  }

  public formatAmount(amount: string) {
    return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  public getLevelBlockNum(row: any, index: string, scope: any) {
    const value = row[`num${index}`];
    const name = row[`name${index}`];
    const total = ((scope.row.levelList)[0])[`num${index}`];
    const each = total / 10;
    const float = value ? (value / each) : 0;
    let levelBlock = '';
    for (let i = 0; i < Math.ceil(float); i++) {
      levelBlock += '<span class="level-block active"></span>';
    }
    for (let i = 0; i < 10 - Math.ceil(float); i++) {
      levelBlock += '<span class="level-block"></span>';
    }
    return `<div class="item-l"><span class="name">${name} </span>${levelBlock}</div><div class="item-r">${this.formatAmount(value)}</div>`;
  }

  public async gearApplyOverviewDatas() {
    const { data } = await gearApplyOverviewDatasApi(this.year);
    data.data.dataList = data.data.dataList ? data.data.dataList : [];
    this.commission = Object.assign({}, this.commission, data.data);
  }
}
